export default __webpack_public_path__ + "static/media/do-1@2x.8404a4a7.jpg";